import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "pill"]

  select({ params: { value }, currentTarget }) {
    this.selectTarget.value = value
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.pillTargets.forEach((p) => p.classList.remove("mode-toggle-pill--active"))
    currentTarget.classList.add("mode-toggle-pill--active")
  }
}
